// İzin Yönetimi sayfası ve pencereleri. Excel ve yanıt e-postası Türkçe kalır.
const leaves = {
  page: {
    title: 'İzin Yönetimi',
    subtitle: 'Tüm çalışanların izin taleplerini tek ekrandan görüntüleyin, onaylayın, reddedin ve yıllık izin bakiyelerini raporlayın.',
    givenLeaves: 'Verilen İzinler',
    addLeave: 'İzin Ekle',
  },
  tabs: {
    label: 'İzin Yönetimi bölümleri',
    requests: 'Talepler',
    balance: 'Bakiye & Rapor',
    pendingCount_one: '{{count}} bekleyen talep',
    pendingCount_other: '{{count}} bekleyen talep',
  },
  common: {
    days_one: '{{days}} gün',
    days_other: '{{days}} gün',
    refresh: 'Yenile',
    cancel: 'İptal',
    save: 'Kaydet',
  },
  stats: {
    share: 'Toplamın %{{percent}}’i',
  },
  status: {
    pending: 'Beklemede',
    approved: 'Onaylandı',
    rejected: 'Reddedildi',
    unknown: 'Bilinmiyor',
  },
  requests: {
    tiles: {
      total: 'Toplam Talep',
      totalShort: 'Toplam',
      pending: 'Bekleyen Talep',
      pendingShort: 'Bekleyen',
      approved: 'Onaylanan',
      approvedShort: 'Onaylı',
      rejected: 'Reddedilen',
      rejectedShort: 'Red',
    },
    search: 'Çalışan adı, e-posta veya izin türü ara…',
    searchShort: 'Çalışan veya izin türü ara…',
    statusFilter: 'Durum',
    filter: {
      all: 'Tümü',
      pending: 'Bekleyen',
      approved: 'Onaylanan',
      rejected: 'Reddedilen',
    },
    listTitle: 'İzin Talepleri',
    empty: 'Gösterilecek izin talebi bulunamadı.',
    rangeOf: '/ {{total}} talep',
    ofTotal: 'toplam {{total}} talep içinden',
    view: 'İzin belgesini görüntüle',
    approve: 'Onayla',
    reject: 'Reddet',
    delete: 'İzin talebini kalıcı olarak sil',
    columns: {
      employee: 'Çalışan',
      email: 'E-posta',
      type: 'İzin Türü',
      start: 'Başlangıç',
      end: 'Bitiş',
      duration: 'Süre',
      travelDays: 'Yol Süresi',
      status: 'Durum',
      requestedAt: 'Talep Tarihi',
      reason: 'İzin Nedeni',
      address: 'Adres',
      processedBy: 'İşleyen',
      actions: 'İşlemler',
    },
  },
  balance: {
    totals: {
      entitlement: 'Toplam Hak (gün)',
      entitlementShort: 'Toplam hak',
      used: 'Kullanılan (gün)',
      usedShort: 'Kullanılan',
      reserved: 'Bekleyen (gün)',
      reservedShort: 'Bekleyen',
      remaining: 'Kalan (gün)',
      remainingShort: 'Kalan',
    },
    search: 'Çalışan adı veya departman ara…',
    searchShort: 'Çalışan veya departman ara…',
    year: 'Yıl',
    export: 'Excel’e Aktar',
    listTitle: 'Yıllık İzin Bakiyeleri — {{year}}',
    rangeOf: '/ {{total}} çalışan',
    share: 'Toplam hakkın %{{percent}}’i',
    empty: 'Gösterilecek çalışan bulunamadı.',
    usageTitle: 'Kullanılan {{used}} · Bekleyen {{reserved}} · Toplam hak {{total}} gün',
    carryOverTitle: '{{from}}–{{to}} yıllarından devreden',
    editEntitlement: 'Yıllık izin hakkını düzenle',
    history: 'Verilen izinleri görüntüle',
    columns: {
      employee: 'Çalışan',
      department: 'Departman',
      annual: 'Yıllık Hak',
      carryOver: 'Devreden',
      entitlement: 'Toplam Hak',
      used: 'Kullanılan',
      reserved: 'Bekleyen',
      remaining: 'Kalan',
      usage: 'Kullanım',
      actions: 'İşlem',
    },
  },
  dialog: {
    title: 'İzin Belgesi',
    start: 'Başlangıç',
    end: 'Bitiş',
    leaveDays: 'İzin/Rapor Süresi',
    travelDays: 'Yol Süresi',
    requestedAt: 'Talep Tarihi',
    file: 'Rapor Dosyası',
    openFile: 'Dosyayı görüntüle',
    reason: 'İzin Nedeni',
    address: 'Adres',
    processedBy: 'İşleyen',
    adminNote: 'Yönetici Notu',
    delete: 'Sil',
    decideHint: 'Onayladığınızda veya reddettiğinizde çalışana e-posta ile bildirilir. Not isteğe bağlıdır.',
    rejectHint: 'Reddetmek için sebep yazmanız gerekir; not çalışana e-posta ile iletilir.',
    notePlaceholder: 'İsteğe bağlı not ekleyebilirsiniz…',
    notePlaceholderReject: 'Red sebebini belirtiniz (zorunlu)…',
    processing: 'İşleniyor…',
  },
  delete: {
    title: 'İzin Talebini Sil',
    message: '{{name}} adlı çalışanın {{type}} talebi kalıcı olarak silinecek.',
    warning: 'Bu işlem geri alınamaz. Devam etmek istiyor musunuz?',
    confirm: 'Kalıcı Olarak Sil',
    deleting: 'Siliniyor…',
  },
  entitlement: {
    title: 'Yıllık İzin Hakkı',
    intro: '{{name}} çalışanının yıllık izin hakkını (gün) güncelleyin.',
    field: 'Her Yılın İzin Hakkı (gün)',
    decrease: 'Bir gün azalt',
    increase: 'Bir gün artır',
    carryOver: 'Devreden',
    used: 'Kullanılan',
    reserved: 'Bekleyen',
    newRemaining: 'Yeni kalan',
    note: 'Değişiklik çalışanın kaydına işlenir ve tüm yılların bakiyesinde kullanılır. Önceki yıllardan kalan günler otomatik devreder.',
    history: 'Verilen izinler',
    saving: 'Kaydediliyor…',
  },
  add: {
    title: 'Yeni İzin Kaydı',
    subtitle: 'Çalışan için izin oluşturun — yıllık izinler ilgili yılın bakiyesinden otomatik düşülür.',
    steps: {
      employee: 'Çalışan',
      employeeHint: 'İzin kaydedilecek çalışanı arayıp seçin.',
      type: 'İzin türü',
      dates: 'Tarih ve süre',
      extra: 'Ek bilgiler',
      extraHint: 'Hepsi isteğe bağlıdır.',
    },
    employeeSearch: 'Çalışan adı veya departman ara…',
    employeesLoading: 'Çalışanlar yükleniyor…',
    noMatch: 'Eşleşen çalışan bulunamadı',
    noDepartment: 'Departman belirtilmemiş',
    change: 'Değiştir',
    balanceTitle: '{{year}} yıllık izin bakiyesi',
    balanceLoading: 'Bakiye hesaplanıyor…',
    balancePlaceholder: 'Çalışan seçtiğinizde yıllık izin bakiyesi burada görünür.',
    remaining: 'Kalan',
    stats: {
      entitlement: 'Toplam hak',
      used: 'Kullanılan',
      reserved: 'Bekleyen',
      after: 'Bu izinden sonra',
    },
    annualNote: 'Yıllık izin, başlangıç tarihinin yılına ait bakiyeden düşülür.',
    notDeducted: 'Bu izin türü yıllık izin bakiyesinden düşülmez.',
    fields: {
      start: 'Başlangıç Tarihi',
      end: 'Bitiş Tarihi',
      leaveDays: 'İzin Süresi (gün)',
      leaveDaysHint: 'Cumartesi 0,5 gün, Pazar sayılmaz — otomatik hesaplanır.',
      travelDays: 'Yol Süresi (gün)',
      reason: 'İzin Nedeni',
      reasonPlaceholder: 'İsteğe bağlı açıklama…',
      address: 'İzindeki Adres',
      addressPlaceholder: 'İzin süresince bulunulacak adres',
    },
    holidays: {
      badge: 'Resmi Tatil',
      summary_one: 'Seçilen aralıkta {{count}} resmi tatil var — izin süresinden {{days}} gün düşülmedi.',
      summary_other: 'Seçilen aralıkta {{count}} resmi tatil var — izin süresinden {{days}} gün düşülmedi.',
      full: 'Tam gün',
      half: 'Yarım gün',
    },
    insufficient: 'Bu izin, çalışanın {{year}} yılı kalan bakiyesini ({{remaining}} gün) aşıyor. Kaydederseniz kalan bakiye {{after}} gün olacaktır.',
    file: {
      choose: 'Rapor / Belge Ekle (isteğe bağlı)',
      hint: 'PDF, JPG, PNG veya Word — tıklayın ya da sürükleyip bırakın',
      remove: 'Kaldır',
    },
    approvedNote: 'Kayıt onaylanmış olarak eklenir. Kaydettikten sonra pencere açık kalır; aynı çalışana yeni izin ekleyebilirsiniz.',
    save: 'İzni Kaydet',
    saving: 'Kaydediliyor…',
    toast: {
      employeesError: 'Çalışan listesi yüklenirken hata oluştu',
      recordsError: 'Çalışanın izin kayıtları yüklenirken hata oluştu',
      noEmployee: 'Lütfen bir çalışan seçiniz',
      noDates: 'Başlangıç ve bitiş tarihlerini giriniz',
      badRange: 'Bitiş tarihi başlangıç tarihinden önce olamaz',
      savedAnnual: '{{name}} için {{days}} günlük izin kaydedildi. {{year}} kalan bakiye: {{remaining}} gün',
      savedOther: '{{name}} için {{type}} kaydedildi',
      saveError: 'İzin kaydedilirken hata oluştu',
    },
  },
  given: {
    title: 'Verilen İzinler',
    subtitle: 'Manuel eklenen izinler ve onaylanmış izin talepleri tek listede.',
    subtitleEmployee: 'Manuel ve onaylanmış izinler · Filtre: {{name}}',
    search: 'Çalışan, departman, izin türü veya neden ara…',
    filters: {
      year: 'Yıl',
      allYears: 'Tüm yıllar',
      type: 'Tür',
      allTypes: 'Tüm izinler',
      source: 'Kaynak',
      allSources: 'Tüm kaynaklar',
      employee: 'Çalışan',
      allEmployees: 'Tüm çalışanlar',
    },
    source: {
      manual: 'Manuel kayıt',
      request: 'Onaylanan talep',
    },
    totalsLabel: 'Filtrelenen kayıtların özeti',
    totals: {
      records: 'Kayıt',
      employees: 'Çalışan',
      totalDays: 'Toplam Gün',
      annualDays: 'Yıllık İzin Günü',
      annualDaysShort: 'Yıllık izin',
      manual: 'Manuel',
    },
    showing_one: '{{count}} kayıt gösteriliyor',
    showing_other: '{{count}} kayıt gösteriliyor',
    clearFilters: 'Filtreleri Temizle',
    loading: 'İzin kayıtları yükleniyor…',
    loadError: 'Verilen izin kayıtları yüklenirken hata oluştu.',
    empty: 'Bu filtrelerle eşleşen izin kaydı yok.',
    pickHint: 'Ayrıntıları görmek için listeden bir izin seçin.',
    columns: {
      employee: 'Çalışan',
      leave: 'İzin',
      dates: 'Tarih',
      days: 'Gün',
      source: 'Kaynak',
    },
    detail: {
      start: 'Başlangıç',
      end: 'Bitiş',
      leaveDays: 'İzin Süresi',
      travelDays: 'Yol Süresi',
      createdAt: 'Kayıt Tarihi',
      reason: 'Neden',
      address: 'Adres',
      adminNote: 'Yönetici Notu',
      processedBy: 'İşleyen',
      openFile: 'Belgeyi Aç',
      noFile: 'Ekli belge yok',
    },
  },
  celebration: {
    welcome: 'Hoş geldin,',
    skip: 'Geç',
  },
  toast: {
    invalidDays: 'Geçerli bir gün sayısı giriniz',
    entitlementSaved_one: '{{name}} yıllık izin hakkı {{count}} gün olarak güncellendi',
    entitlementSaved_other: '{{name}} yıllık izin hakkı {{count}} gün olarak güncellendi',
    entitlementError: 'Yıllık izin hakkı güncellenirken hata oluştu',
    reportError: 'İzin bakiye raporu yüklenirken hata oluştu',
    exportEmpty: 'Dışa aktarılacak kayıt bulunamadı',
    exported: 'Excel dosyası indirildi',
    loadError: 'İzin talepleri yüklenirken hata oluştu',
    rejectNoteRequired: 'Red sebebi belirtmelisiniz',
    approved: 'İzin talebi onaylandı',
    rejected: 'İzin talebi reddedildi',
    actionError: 'İzin talebi güncellenirken hata oluştu',
    deleted: 'İzin talebi kalıcı olarak silindi',
    deleteError: 'İzin talebi silinirken hata oluştu',
  },
  types: {
    yillik: 'Yıllık İzin',
    mazeret: 'Mazeret İzni',
    raporlu: 'Raporlu',
    dogum_oncesi: 'Doğum Öncesi İzin',
    babalik: 'Babalık İzni',
    evlilik: 'Evlilik İzni',
    olum: 'Ölüm İzni',
    engelli_cocuk: 'Engelli Çocuk Mazeret İzni',
    dogum_sonrasi: 'Doğum Sonrası İzin',
    yatakli_tedavi: 'Yataklı Kurumda Tedavi',
    refakat: 'Refakat İzni',
    sua: 'Şua İzni',
    saglik_kurulu: 'Sağlık Kurulu Raporu',
    ayakta_tedavi: 'Ayakta Tedavi',
  },
};

export default leaves;
